module.exports = __webpack_public_path__ + "static/media/44import.d8b3ca6f.xlsx";